import signUpImg from '../../images/secure_signup_2.svg'
import searchImg from '../../images/search_lots.svg'
import bookSLotImg from '../../images/book_parking_lot.svg'

const howToUseData = [
    {
        heading:"Register",
        subHeading:"Register to create you account by filling simple details, Only verified accounts can use Smart Parking",
        img:signUpImg
    },
    {
        heading:"Search",
        subHeading:"Search for the fully verified parking lots near you according to you feasibility and affodability",
        img:searchImg
    },
    {
        heading:"Book",
        subHeading:"Book a parking slot by sorting and filtering out the best slot for you, Pay smoothly and Park!",
        img:bookSLotImg
    }
]

export default howToUseData;